import React from "react";

// ──────────────────────────────────────────────────────
// Footer.jsx — 로그인/가입 하단 사업자 정보 (SNS 앱 승인용 + 법적 고지)
//   loginhs.co.kr 홈페이지 톤(연회색·· 구분·은은한 상단선)으로 정리. 문의하기 추가.
// ──────────────────────────────────────────────────────

const LINK = "#4b5563"; // 링크 (near-black 계열 회색)
const MUTED = "#9aa0ad"; // 본문 회사정보
const SEP = "#d1d5db"; // 구분점

const linkStyle = {
  color: LINK,
  textDecoration: "none",
  fontWeight: 600,
};
const Dot = () => <span style={{ color: SEP }}>·</span>;

const Footer = () => {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "12px 16px",
        textAlign: "center",
        fontSize: "11.5px",
        lineHeight: 1.7,
        color: MUTED,
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(6px)",
        borderTop: "1px solid #ecedf2",
        boxSizing: "border-box",
        zIndex: 10,
      }}
    >
      {/* 링크 행 */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          fontSize: "12px",
          marginBottom: "4px",
        }}
      >
        <a
          href="https://docuai.tlogin.net/privacyPolicy"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          개인정보처리방침
        </a>
        <Dot />
        <a
          href="https://docuai.tlogin.net/termsOfUse"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          이용약관
        </a>
        <Dot />
        <a href="/?page=contact" style={linkStyle}>
          문의하기
        </a>
        <Dot />
        <a
          href="https://logins.kr/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          홈페이지
        </a>
      </div>

      {/* 사업자 정보 */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px 8px",
        }}
      >
        <span>(주)로그인네트웍</span>
        <Dot />
        <span>대표 김정민</span>
        <Dot />
        <span>사업자등록번호 121-86-03351</span>
        <Dot />
        <span>통신판매 2019-인천중구-0407</span>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px 8px",
        }}
      >
        <span>연락처 032-744-6000</span>
        <Dot />
        <span>인천광역시 중구 화랑목로 40-8 (운서동) 102·103·104호</span>
      </div>
    </footer>
  );
};

export default Footer;
